import { render, staticRenderFns } from "./roomRzxz.vue?vue&type=template&id=d237880a&scoped=true&"
import script from "./roomRzxz.vue?vue&type=script&lang=js&"
export * from "./roomRzxz.vue?vue&type=script&lang=js&"
import style0 from "./roomRzxz.vue?vue&type=style&index=0&id=d237880a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d237880a",
  null
  
)

export default component.exports